"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MiniProviderCard = void 0;
var MiniProviderCard_1 = require("./MiniProviderCard");
Object.defineProperty(exports, "MiniProviderCard", { enumerable: true, get: function () { return __importDefault(MiniProviderCard_1).default; } });
//# sourceMappingURL=index.js.map